// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_2a2431e"};